import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
  SelectSearch,
} from 'components';
import {
  CleanIcon,
  TrashIcon,
  EditIcon,
  AddIcon,
  ViewIcon,
  StarActiveIcon,
} from 'assets/icons';
import { RatingService } from 'services';
import moment from 'moment';
import ModalView from './modal-view';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
  lawyer_id: '',
  since: '',
  until: '',
};

class AdminRatings extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: [
      'ID Orden',
      'Fecha',
      'Cliente',
      'Abogado',
      'Tipo de tramite',
      'Calificación',
      'Acciones',
    ],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    lawyers: [],
    visible: false,
    item: null,
    lawyer: null,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Calificación',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.loadData();
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await RatingService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      since:
        this.state.form.since &&
        moment(this.state.form.since).format('YYYY-MM-DD'),
      until:
        this.state.form.until &&
        moment(this.state.form.until).format('YYYY-MM-DD'),
    });
    this.setState({
      data: res.ratings.rows,
      last_page: res.ratings.count,
      lawyer: res.lawyer,
    });
  };

  loadData = async () => {
    const res: any = await RatingService.admin.getLawyers({
      withoutLoading: true,
    });
    this.setState({
      lawyers: res.lawyers || [],
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  view = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
      item: null,
    });
  };

  render() {
    const { visible } = this.state;
    const lawyer: any = this.state.lawyers.find(
      (i: any) => i.id == this.state.form.lawyer_id,
    );
    const lawyer_info: any = this.state.lawyer;

    return (
      <div id="admin-ratings">
        <Modal
          className="modal-view-rating"
          visible={visible}
          title="Calificación"
          onClose={() => this.onClose()}
        >
          <ModalView
            item={this.state.item}
            history={this.props.history}
            onClose={() => this.onClose()}
          />
        </Modal>

        <div className="row row-filter">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-11 row">
                <div className="col-md-3">
                  <Input
                    value={this.state.form.search}
                    name="search"
                    placeholder="Buscar"
                    label="Cliente"
                    className="input-table"
                    onSubmit={() => this.load()}
                    onChange={(e: any) => {
                      clearTimeout(this.timer);
                      this.timer = setTimeout(() => {
                        this.load(true);
                      }, 1000);
                      this.change(e);
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <SelectSearch
                    placeholder="Seleccione"
                    label="Abogado"
                    onChange={(lawyer: any) => {
                      this.setState(
                        {
                          form: {
                            ...this.state.form,
                            lawyer_id: lawyer?.value,
                          },
                        },
                        () => this.load(true),
                      );
                    }}
                    color="white"
                    searchRight
                    value={
                      lawyer
                        ? {
                            value: lawyer.id,
                            label: lawyer.name + ' ' + lawyer.lastname,
                          }
                        : null
                    }
                    options={this.state.lawyers.map((item: any) => {
                      return {
                        label: item.name + ' ' + item.lastname,
                        value: item.id,
                      };
                    })}
                  />
                </div>
                <div className="col-md-3">
                  <DatePicker
                    label="Desde"
                    placeholder="Desde"
                    onChange={(text: string) => {
                      this.change(
                        {
                          target: {
                            value: text,
                            name: 'since',
                          },
                        },
                        () => this.load(true),
                      );
                    }}
                    value={this.state.form.since}
                  />
                </div>
                <div className="col-md-3">
                  <DatePicker
                    label="Hasta"
                    placeholder="Hasta"
                    onChange={(text: string) => {
                      this.change(
                        {
                          target: {
                            value: text,
                            name: 'until',
                          },
                        },
                        () => this.load(true),
                      );
                    }}
                    value={this.state.form.until}
                  />
                </div>
              </div>
              <div className="col-md-1">
                {this.state.form != INITIAL_STATE && (
                  <button
                    className="btn btn-clean"
                    onClick={() => this.reset()}
                  >
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title="Calificación"
          data={this.state.data.length}
          header={this.state.header}
          rightAlign={[6]}
          headerContent={
            <>
              {lawyer_info && (
                <div className="lawyer-container">
                  <div className="star-container">
                    <img src={StarActiveIcon} />
                  </div>
                  <p className="name">{lawyer_info?.full_name}</p>
                  <p className="points">
                    {parseFloat(lawyer_info?.average || 0).toFixed(2)}
                  </p>
                </div>
              )}
            </>
          }
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>
                  {i.revision?.number ||
                    i.preparation?.number_format ||
                    i.call?.number ||
                    i.signature?.number}
                </td>
                <td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
                <td>{i.user?.full_name}</td>
                <td>{i.lawyer?.full_name}</td>
                <td>{i.name}</td>
                <td>
                  <div className="container-rating">
                    {i.rating >= 1 && <img src={StarActiveIcon} />}
                    {i.rating >= 2 && <img src={StarActiveIcon} />}
                    {i.rating >= 3 && <img src={StarActiveIcon} />}
                    {i.rating >= 4 && <img src={StarActiveIcon} />}
                    {i.rating >= 5 && <img src={StarActiveIcon} />}
                  </div>
                </td>
                <td className="text-right">
                  <Tooltip title="Ver">
                    <a
                      className="link-icon"
                      href="#"
                      onClick={(e: any) => this.view(e, i)}
                    >
                      <img src={ViewIcon} />
                    </a>
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminRatings);
